import React from 'react';
const ImageElement = () => <div className="builder-image" style={{padding:'1rem',border:'1px dashed #ccc'}}>🖼️ Image (Coming Soon)</div>;
export default ImageElement;
